import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Store } from "lucide-react";
import { SHOP_CATEGORIES, SITE } from "@/data/site";

export default function Shop() {
  return (
    <div data-testid="shop-page">
      <section className="border-b border-white/10 bg-[#111] relative grain">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <p className="label-industrial text-ember mb-4">Retail Shop</p>
          <h1 className="font-display text-6xl lg:text-8xl tracking-wide text-white" data-testid="shop-heading">
            OVER THE COUNTER
          </h1>
          <p className="mt-6 text-gray-400 max-w-xl">
            Our retail shop stocks the essentials for the road and the water. Pop in to the store at {SITE.location} or give us a ring to check stock.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10" data-testid="shop-grid">
          {SHOP_CATEGORIES.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 2) * 0.08 }}
              className="group bg-[#111]"
              data-testid={`shop-category-${i}`}
            >
              <div className="h-64 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-300"
                />
              </div>
              <div className="p-10 border-t-2 border-ember">
                <h2 className="font-display text-4xl tracking-wide text-white mb-3">{c.title}</h2>
                <p className="text-gray-400 text-sm leading-relaxed">{c.blurb}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 border border-white/10 bg-[#111] p-10 flex flex-col md:flex-row items-center gap-8" data-testid="shop-eziswap">
          <div className="bg-white p-6 shrink-0" data-testid="eziswap-logo">
            <img src="/img/eziswap-gas.webp" alt="Eziswap Gas logo" className="h-24 w-auto" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <p className="label-industrial text-ember mb-2">Official Stockist</p>
            <h3 className="font-display text-4xl tracking-wide text-white mb-3">EZISWAP GAS</h3>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xl">
              Your local Eziswap Gas agent — swap and go LPG and industrial gas bottles over the counter. Pop in and swap your empty for a full one.
            </p>
          </div>
        </div>

        <div className="mt-8 border border-white/10 bg-[#111] p-10 flex flex-col sm:flex-row items-start sm:items-center gap-6" data-testid="shop-visit-banner">
          <Store className="w-10 h-10 text-ember shrink-0" />
          <div className="flex-1">
            <h3 className="font-display text-3xl tracking-wide text-white">VISIT THE SHOP</h3>
            <p className="text-gray-400 text-sm mt-2">
              {SITE.location} — open {SITE.hours[0].days.toLowerCase()}, {SITE.hours[0].time}. Call {SITE.phone} to check availability.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="shop-enquire-btn"
            className="label-industrial bg-ember text-white px-8 py-4 hover:bg-ember-hover transition-colors duration-150 shrink-0"
          >
            Enquire Now
          </Link>
        </div>
      </section>
    </div>
  );
}
